import React from 'react';
import SetsItem from '../setsItem/SetsItem';
import classNames from 'classnames';

const SetsInfo = React.forwardRef(({ button, gradeData, activeCash }, ref) => {
  return (
    <>
      {!button && (
        <div className={classNames('sets__info')}>
          <div className={'sets__info-block'}>{items(gradeData?.cost, activeCash)}</div>
        </div>
      )}
    </>
  );

  function items(items = [], cash) {
    return items.map((props, index) => <SetsItem key={'SetsItem-' + index} {...props} cash={cash} />);
  }
});
export default SetsInfo;
SetsInfo.displayName = 'SetsInfo';
SetsInfo.propTypes = {};
